import type { CSSProperties } from "react";

import type { ResizeHandle } from "@skilitics/drag-drop";

export const propertiesEventTypes = {
  UPDATE_NODE_DIMENSIONS: "UPDATE_NODE_DIMENSIONS",
  RESIZE_NODE_DIMENSIONS: "RESIZE_NODE_DIMENSIONS",
  TRANSFORM_ORIGIN_CHANGE: "TRANSFORM_ORIGIN_CHANGE",
};

export type DimensionsUpdateEventOptions = {
  nodeId: number;
  width: CSSProperties["width"];
  height: CSSProperties["height"];
};

export type ResizeNodeDimensionsEventOptions = {
  nodeId: number;
  handle: ResizeHandle;
  widthDelta?: number;
  heightDelta?: number;
  width?: CSSProperties["width"];
  height?: CSSProperties["height"];
};

export type TransformOriginChangeEventOptions = {
  nodeId: number;
  fractions: { ox: number; oy: number };
  startFractions: { ox: number; oy: number };
};
